import { render, staticRenderFns } from "./OpportunityListWrapper.vue?vue&type=template&id=3cb300d5&scoped=true&"
import script from "./OpportunityListWrapper.vue?vue&type=script&lang=js&"
export * from "./OpportunityListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityListWrapper.vue?vue&type=style&index=0&id=3cb300d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb300d5",
  null
  
)

export default component.exports